import { render, staticRenderFns } from "./DemoAcceptPopup.vue?vue&type=template&id=fce7045a&scoped=true"
import script from "./DemoAcceptPopup.vue?vue&type=script&lang=js"
export * from "./DemoAcceptPopup.vue?vue&type=script&lang=js"
import style0 from "./DemoAcceptPopup.vue?vue&type=style&index=0&id=fce7045a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fce7045a",
  null
  
)

export default component.exports